// extracted by mini-css-extract-plugin
export default {"WorkPermitsFilters":"WorkPermitsFilters_WorkPermitsFilters__CrXE9"};